module.exports = __webpack_public_path__ + "img/HSS-material.62722c0d.jpg";